export default __webpack_public_path__ + "static/media/gnome2.2b8d2ccc.png";